import { render, staticRenderFns } from "./EditIdentifiants.vue?vue&type=template&id=73920ecc&scoped=true&"
import script from "./EditIdentifiants.vue?vue&type=script&lang=js&"
export * from "./EditIdentifiants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73920ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73920ecc')) {
      api.createRecord('73920ecc', component.options)
    } else {
      api.reload('73920ecc', component.options)
    }
    module.hot.accept("./EditIdentifiants.vue?vue&type=template&id=73920ecc&scoped=true&", function () {
      api.rerender('73920ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EditIdentifiants.vue"
export default component.exports